// use-pagination.ts
import "@adornis/baseql/utils/queryGeneration.js";
import { useEffect, useState } from "@adornis/functional-lit/stateful.js";
import "rxjs";
function usePagination({
  queryOrSubscription,
  args,
  selectionSet,
  initialPagination = 20,
  paginationStep = 20
}) {
  const resetCacheKey = JSON.stringify(args);
  const [data, setData] = useState([], [resetCacheKey]);
  const [totalRequested, setTotalRequested] = useState(initialPagination, [resetCacheKey]);
  const [complete, setComplete] = useState(false, [resetCacheKey]);
  const [loadingInitially, setLoadingInitially] = useState(true, [resetCacheKey]);
  const [parameters, setParameters] = useState(args, [resetCacheKey]);
  useEffect(() => {
    const isSubscription = "subscribe" in queryOrSubscription(0, 0, ...parameters)(selectionSet);
    if (isSubscription) {
      const subscription = queryOrSubscription(0, totalRequested, ...parameters)(selectionSet).subscribe((newData) => {
        setData(newData);
        setLoadingInitially(false);
        if (newData.length < totalRequested)
          setComplete(true);
      });
      return () => {
        subscription.unsubscribe();
      };
    } else {
      let isCancelled = false;
      const fetchData = async () => {
        setLoadingInitially(true);
        try {
          const newData = await queryOrSubscription(0, totalRequested, ...parameters)(selectionSet);
          if (isCancelled)
            return;
          setData(
            ((prevData) => {
              if (totalRequested <= prevData.length) {
                return newData;
              }
              return [...prevData, ...newData.slice(prevData.length)];
            })(data)
          );
          setLoadingInitially(false);
          if (newData.length < totalRequested)
            setComplete(true);
        } catch (error) {
          if (isCancelled)
            return;
          console.error("Error fetching data:", error);
          setLoadingInitially(false);
        }
      };
      fetchData();
      return () => isCancelled = true;
    }
  }, [totalRequested, resetCacheKey]);
  const next = () => {
    if (!complete) {
      setTotalRequested(totalRequested + paginationStep);
    }
  };
  const updateParameters = (...newArgs) => {
    setParameters(newArgs);
  };
  return {
    data,
    totalRequested,
    complete,
    loadingInitially,
    next,
    updateParameters
  };
}
export {
  usePagination
};
